"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = require("@bit/knotchinc.web-react-components.grid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * In order to deal with arbitrary amount of columns and
 * hardcoded Grid height, the AutoGrid will generate a set of
 * rows with the proper height based on the amount of components
 * passed in col and the number of cols per rows specified.
 *
 * @param {Number} rowHeight
 * @param {Array} cols
 * @param {Number} colsPerRow
 */
var AutoGrid = function AutoGrid(_ref) {
  var rowHeight = _ref.rowHeight,
      cols = _ref.cols,
      _ref$colsPerRow = _ref.colsPerRow,
      colsPerRow = _ref$colsPerRow === void 0 ? 3 : _ref$colsPerRow,
      gridStyle = _ref.gridStyle;
  var rows = [];
  var rowIndex = -1;

  for (var i = 0; i < cols.length; i++) {
    if (i % colsPerRow === 0) {
      rows.push([]);
      rowIndex++;
    }

    rows[rowIndex].push(cols[i]);
  }

  while (rows[rowIndex].length < colsPerRow) {
    rows[rowIndex].push(_react["default"].createElement(_knotchincWebReactComponents.Col, null));
  }

  return function () {
    return _react["default"].createElement(_knotchincWebReactComponents.Grid, {
      height: rows.length * rowHeight,
      gridStyle: gridStyle
    }, rows.map(function (colGroups, rowIdx) {
      return _react["default"].createElement(_knotchincWebReactComponents.Row, {
        key: "Row-".concat(rowIdx)
      }, colGroups.map(function (col, colIdx) {
        return _react["default"].createElement(_knotchincWebReactComponents.Col, {
          key: "Row-".concat(rowIdx, "-Col-").concat(colIdx)
        }, col);
      }));
    }));
  };
};

var _default = AutoGrid;
exports["default"] = _default;

//# sourceMappingURL=AutoGrid.js.map